import {
  type BackgroundCheckConsentConfigurationsResponse,
  BackgroundCheckConsentConfigurationsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

const getBackgroundCheckConsentConfigurationsUrl = (workerId: string) =>
  `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/background-check-consent-configurations`;

export const getBackgroundCheckConsentConfigurationsQueryKey = (workerId: string) => [
  getBackgroundCheckConsentConfigurationsUrl(workerId),
];

export function useGetBackgroundCheckConsentConfigurations(
  params: { workerId: string },
  options: UseGetQueryOptions<BackgroundCheckConsentConfigurationsResponse> = {}
) {
  const { workerId } = params;
  return useGetQuery({
    url: getBackgroundCheckConsentConfigurationsUrl(workerId),
    queryParams: {
      filter: {
        vendor: "checkr",
      },
    },
    responseSchema: BackgroundCheckConsentConfigurationsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_BACKGROUND_CHECK_CONSENT_CONFIGURATIONS_FAILURE,
    },
    ...options,
  });
}
